import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useForm, FormProvider } from "react-hook-form";
import { MotifIcon } from "@ey-xd/motif-react";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import PageTitle from "@/components/Form/PageTitle/PageTitle";
import CustomTabPanel from "../../Claim/claimSetup/CustomTabPanel";
import { useCase } from "@/features/case/use-case";
import Details from "./details/Details";
import ClaimItems from "./claimItems/ClaimItems";
import Claim from "./claim/Claim";
import { ActiveTabsOrder } from "@/menuData";
import "./Paymentsetup.scss";
const PaymentSetup = () => {
  const { t } = useTranslation();
  const { caseId } = useParams();
  const [shouldFetch, setShouldFetch] = useState(false);
  const caseData = useCase(caseId, shouldFetch);
  const { defaultUnit, caseName } = caseData;
  useEffect(() => {
    if (!defaultUnit) {
      setShouldFetch(true);
    }
  }, [defaultUnit]);
  const [creditorValue, setCreditorValue] = useState("");
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const methods = useForm({
    defaultValues: {
      distribution: "",
      subAccount: "",
      prefix: "",
      paymentOption: "",
      paymentAmount: "",
      unit: "",
      selectedUnit: "",
      accountUnit: "",
      unitDecimalPlace: "",
      exchangeRate: 1,
      creditorName: "",
      creditorId: "",
      claimReferenceId: "",
      claimId: "",
      claimItems: [],
      generateClaimItemIds: [],
      generatePaymentItems: [],
      addedClaimItemIds: [],
    },
    mode: "onSubmit",
  });
  const breadcrumbItem = [
    {
      label: "Back",
      elementKey: "Back",
      text: caseName,
      url: `/case/${caseId}/?activeTab=${ActiveTabsOrder.PAYMENT}`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
    },
    {
      text: t("pages.paymentStatus.breadCrums.createPayment"),
      url: `/`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
      disabled: true,
    },
  ];
  const handleTabChange = (index: number) => {
    setActiveTabIndex(index);
  };
  const [formSubmissionStatus, setFormSubmissionStatus] = useState({
    details: false,
    claim: false,
    claimItems: false,
  });
  const updateFormSubmissionStatus = (formName: any, status: any) => {
    setFormSubmissionStatus((prevStatus) => ({
      ...prevStatus,
      [formName]: status,
    }));
  };
  const goToNextTab = () => {
    setActiveTabIndex((prevIndex) => prevIndex + 1);
    const currentFormName = tabs[activeTabIndex].name;
    updateFormSubmissionStatus(currentFormName, true);
  };
  const tabs = [
    {
      name: "paymentDetails",
      label: t("pages.paymentStatus.paymentSetup.sideTabPanelDetails.details"),
      component: (
        <Details
          goToNextTab={goToNextTab}
          creditorValue={creditorValue}
          setCreditorValue={setCreditorValue}
        />
      ),
    },
    {
      name: "selectClaim",
      label: t("pages.paymentStatus.paymentSetup.sideTabPanelDetails.claims"),
      component: <Claim goToNextTab={goToNextTab} />,
    },
    {
      name: "selectClaimItem",
      label: t(
        "pages.paymentStatus.paymentSetup.sideTabPanelDetails.claimItems"
      ),
      component: <ClaimItems />,
    },
  ];
  return (
    <div className="manual-payment-setup">
      <div>
        <Breadcrumb items={breadcrumbItem} ariaLabel="Breadcrumb navigation" />
      </div>
      <PageTitle
        title={"pages.paymentStatus.paymentSetup.title"}
        description={"pages.paymentStatus.paymentSetup.description"}
      />
      <FormProvider {...methods}>
        <CustomTabPanel
          tabs={tabs}
          activeTabIndex={activeTabIndex}
          onTabChange={handleTabChange}
          formSubmissionStatus={formSubmissionStatus}
        />
      </FormProvider>
    </div>
  );
};
export default PaymentSetup;
